// Actions on a subscription the user already has - pause/resume/cancel/change plan and invoices.
import { getData } from '../plugins/ApiCalls'

export function pauseSubscription(id, reason) {
  return getData('subscriptions/' + id + '/pause', {
    params: reason ? { reason } : {}
  })
}

export function resumeSubscription(id) {
  return getData('subscriptions/' + id + '/resume')
}

export function cancelSubscription(id, reason) {
  return getData('subscriptions/' + id + '/cancel', {
    params: reason ? { reason } : {}
  })
}

// Reverses a scheduled Paddle Billing cancellation before the subscription ends.
export function undoCancellation(id) {
  return getData('subscriptions/' + id + '/undo-cancellation')
}

export function updateSubscription(id, params) {
  return getData('subscriptions/' + id + '/update', {
    params: params || {}
  })
}

// Fetches the user's latest invoices split by Paddle source (Classic vs Billing) - each
// invoice, Billing included, already carries its receipt_url ready to open.
export function listInvoicesBySource() {
  return getData('subscriptions/list-invoices')
}
